import { axiosClient } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { ChatConfiguration, ServicePayload } from '@nx-frontend/shared/types';

interface GetChatConfigurationProps extends Omit<ServicePayload, 'userId'> {
  configurationKey: string;
  superSecret: string;
}

export function getChatConfiguration({
  configurationKey,
  superSecret,
}: GetChatConfigurationProps): Promise<ChatConfiguration> {
  return axiosClient
    .get<ChatConfiguration>(`${generalEnv.chatApiUrl}/configurations/${configurationKey}`, {
      secret: superSecret,
    })
    .then((response) => response.data);
}

export function generateChatConfigurationKey({
  orgId,
  workspaceId,
  portalId,
  widgetId,
}: {
  orgId: string;
  workspaceId: string;
  portalId: string;
  widgetId: string;
}): string {
  return `portalWidget_${orgId}_${workspaceId}_${portalId}_${widgetId}`;
}

export function parseChatConfigurationKey(key: string): {
  orgId: string;
  scope: string;
  widgetId: string;
} {
  const [, orgId, scope, widgetId] = key.split('_');
  if (widgetId == null || scope == null || orgId == null) {
    throw new Error(`invalid configuration key ${key}`);
  }

  return { orgId, scope, widgetId };
}
